import { useEffect, useMemo } from "react";

import { useTogglePlay } from "./useTogglePlay";
import { useToggleEdit } from "./useToggleEdit";
import { useSkipForward, useSkipBackward } from "./useSkip";
import { useDecreaseSpeed, useIncreaseSpeed } from "./useSpeed";
import {  isCombination, Shortcuts } from "../constants/shortcuts";

const type = "keydown";

export const useShortcuts = () => {
  const { togglePlay } = useTogglePlay();
  const { toggleIsEdit } = useToggleEdit();
  const skipBackward = useSkipBackward();
  const skipForward = useSkipForward();
  const decreaseSpeed = useDecreaseSpeed();
  const increaseSpeed = useIncreaseSpeed();
  const callbacks = useMemo<Record<Shortcuts, Function>>(() => ({
    [Shortcuts.KeyE]: toggleIsEdit,
    [Shortcuts.ArrowUp]: increaseSpeed,
    [Shortcuts.ArrowDown]: decreaseSpeed,
    [Shortcuts.ArrowLeft]: skipBackward,
    [Shortcuts.ArrowRight]: skipForward,
    [Shortcuts.Space]: togglePlay,
  }), [togglePlay, toggleIsEdit, skipBackward, skipForward, decreaseSpeed, increaseSpeed]);

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const { code } = event;
      const callback = callbacks[code as Shortcuts];

      if (isCombination(event) && callback) {
        callback(event);
      }
    };

    document.addEventListener(type, handler);

    return () => {
      document.removeEventListener(type, handler);
    };
  }, [callbacks]);
};
